import { CERTIFIER_ROOT } from './endpoints.js';
export const IMS_CERTIFICATION_URL =
    'https://site.imsglobal.org/certifications/amelay-corporation-sa-pok/proof-of-knowledge';

export const SIGNUP_URL = CERTIFIER_ROOT + '/region-selector?signup=true';

export const POK_NAME = 'POK - Proof of Knowledge';

export const POK_FACTS = { institutions: 1100, countries: 19 };
export const POK_INSTITUTIONS_LABEL = POK_FACTS.institutions.toLocaleString('en-US');
